import { config } from "./config"; // 加载配置
import { ondays } from "./TimeTable";
import { apiRequest } from "./api";

const PROD_APPOINTMENT_TABLE = "clinic_appointment_system";
const PROD_PATIENT_TABLE = "clinic_patient_db";
const DEMO_APPOINTMENT_TABLE = "clinic_appointment_system_demo";
const DEMO_PATIENT_TABLE = "clinic_patient_db_demo";
const REPORT_DB_MODE_KEY = "reportUseProductionDb";

const isMasterEnvironment = () => window.location.href.includes("master");

export const isDevDbSwitchAvailable = () => !isMasterEnvironment();

const readReportUseProductionDb = () => {
  if (!isDevDbSwitchAvailable()) {
    return true;
  }
  return localStorage.getItem(REPORT_DB_MODE_KEY) === "true";
};

let tableName = PROD_APPOINTMENT_TABLE;
let patientTableName = PROD_PATIENT_TABLE;

const applyDbTableNames = () => {
  if (!isDevDbSwitchAvailable()) {
    tableName = PROD_APPOINTMENT_TABLE;
    patientTableName = PROD_PATIENT_TABLE;
    return;
  }
  const useProduction = readReportUseProductionDb();
  tableName = useProduction ? PROD_APPOINTMENT_TABLE : DEMO_APPOINTMENT_TABLE;
  patientTableName = useProduction ? PROD_PATIENT_TABLE : DEMO_PATIENT_TABLE;
};

applyDbTableNames();

export const getReportUseProductionDb = () => readReportUseProductionDb();

export const setReportUseProductionDb = (useProduction) => {
  if (!isDevDbSwitchAvailable()) {
    return;
  }
  localStorage.setItem(REPORT_DB_MODE_KEY, useProduction ? "true" : "false");
  applyDbTableNames();
};

export const getReportPatientTableName = (useProductionDb) => {
  if (!isDevDbSwitchAvailable() || useProductionDb) {
    return PROD_PATIENT_TABLE;
  }
  return DEMO_PATIENT_TABLE;
};

export const getReportAppointmentTableName = (useProductionDb) => {
  if (!isDevDbSwitchAvailable() || useProductionDb) {
    return PROD_APPOINTMENT_TABLE;
  }
  return DEMO_APPOINTMENT_TABLE;
};

export const getPatientTableName = () => patientTableName;

export const getAppointmentTableName = () => tableName;

let numberOfWeeks = config.numberOfWeeks;
const numberOfLeaveWeeks = config.numberOfLeaveWeeks;
const numberOfPastWeeks = config.numberOfPastWeeks;
const managementPastWeeks = Math.ceil((config.managementPastDays || 0) / 7);
const effectivePastWeeks = Math.max(numberOfPastWeeks, managementPastWeeks);
const scheduleWeeks = Math.max(numberOfWeeks, numberOfLeaveWeeks);

export const SPECIAL_CLINIC_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSct-MMZ2hHC6Sypa6oSFHafZpufvTEv5Q85OFTvnAYMWjL0MA/viewform?usp=header";

export const extraOpenHourKey = (entry) =>
  typeof entry === "string" ? entry : entry?.hour;

export const extraOpenHourType = (entry) =>
  typeof entry === "string" ? "regular" : entry?.type || "regular";

export const findExtraOpenEntry = (hours, hour) =>
  (hours || []).find((entry) => extraOpenHourKey(entry) === hour) || null;

export const isExtraOpenHour = (hours, hour) =>
  Boolean(findExtraOpenEntry(hours, hour));

export const isSpecialExtraOpenHour = (hours, hour) =>
  extraOpenHourType(findExtraOpenEntry(hours, hour)) === "special";

export const applyExtraOpenToScheduleData = (
  scheduleData,
  extraOpenRecord,
  clinic_name
) => {
  if (!scheduleData || !extraOpenRecord?.data?.[clinic_name]) {
    return scheduleData;
  }
  const merged = JSON.parse(JSON.stringify(scheduleData));
  const extras = extraOpenRecord.data[clinic_name];
  Object.entries(extras).forEach(([ymd, hours]) => {
    hours.forEach((entry) => {
      const hour = extraOpenHourKey(entry);
      if (hour && merged[ymd]?.hours?.[hour]) {
        merged[ymd].hours[hour].show = true;
      }
    });
  });
  return merged;
};

export const applyExtraOpenForClinic = (
  scheduleData,
  extraOpenRecord,
  clinic_name
) => {
  if (!scheduleData || !extraOpenRecord) {
    return scheduleData;
  }
  if (clinic_name === "all") {
    return applyExtraOpenToScheduleData(
      applyExtraOpenToScheduleData(scheduleData, extraOpenRecord, "hansheng"),
      extraOpenRecord,
      "yoyo"
    );
  }
  return applyExtraOpenToScheduleData(
    scheduleData,
    extraOpenRecord,
    clinic_name
  );
};

const updateOndaysData = (sortData, onDaysData) => {
  // check if time is full
  Object.keys(sortData).forEach((date) => {
    Object.keys(sortData[date]).forEach((time) => {
      // if (time === "onste") {
      //   //skip the loop
      //   return;
      // }
      let first = 0;
      let all = 0;
      sortData[date][time].forEach((people) => {
        const hour = people.hour;
        all = all + 1;
        if (people.first) {
          // console.log("date:", date, "hour:", hour, "time:", time);
          onDaysData[date].hours[hour][time].people.first.push(people);

          first++;
        } else {
          onDaysData[date].hours[hour][time].people.follow.push(people);
        }
        if (first >= onDaysData[date].hours[hour][time].first) {
          onDaysData[date].hours[hour][time].isFullFirst = true;
        }
        if (all >= onDaysData[date].hours[hour][time].all) {
          onDaysData[date].hours[hour][time].isFullAll = true;
          onDaysData[date].hours[hour][time].isFullFirst = true;
        }
      });
    });
  });
  // check if hour is full
  Object.keys(onDaysData).forEach((date) => {
    Object.keys(onDaysData[date].hours).forEach((hour) => {
      let isFullAll = true;
      let isFullFirst = true;
      Object.keys(onDaysData[date].hours[hour]).forEach((time) => {
        //! 需要排除掉不是時間的 key
        if (!/^[0-9]/.test(time[0])) {
          return;
        }
        // if (time === "onste"){
        //   return;
        // }

        if (onDaysData?.[date]?.hours?.[hour]?.[time]?.isFullAll === false) {
          isFullAll = false;
        }
        if (onDaysData?.[date]?.hours?.[hour]?.[time]?.isFullFirst === false) {
          isFullFirst = false;
        }
      });
      onDaysData[date].hours[hour].isFullAll = isFullAll;
      onDaysData[date].hours[hour].isFullFirst = isFullFirst;
    });
  });
  return onDaysData;
};

// ---- 資料存取：全部透過 backend/ 的業務端點（api.js），前端不再決定資料表或查詢條件 ----

// 目前頁面用的資料庫：master 一律 prod；其他環境依 Demo/正式 切換
export const currentDb = () => (readReportUseProductionDb() ? "prod" : "demo");

const dbForPatientTable = (patientTable) =>
  patientTable === DEMO_PATIENT_TABLE ? "demo" : "prod";

// 可以在預約頁代客掛號、取消的帳號（對應後端 hansheng / yoyo / admin 群組）
export const isFrontDeskUser = (user) =>
  ["admin", "hansheng", "yoyo"].includes(user?.account);

const bookingPath = (user, suffix = "") =>
  `${isFrontDeskUser(user) ? "/staff" : "/public"}/appointments${suffix}`;

// 掛號（初診 / 複診）。dryRun 只檢查不寫入，用來在確認視窗前提早顯示錯誤。
// 失敗時丟出 ApiError，用 errorMessage(err) 取得提示文字。
export const createAppointment = async (appointment, { user, dryRun = false } = {}) =>
  apiRequest("POST", bookingPath(user), {
    auth: isFrontDeskUser(user),
    body: { ...appointment, db: currentDb(), dryRun },
  });

// 病人用證號 + 生日查自己的預約
export const lookupAppointments = async ({ clinic, ID, birthday }) => {
  const res = await apiRequest("POST", "/public/appointments/lookup", {
    body: { db: currentDb(), clinic, ID, birthday },
  });
  return res.appointments;
};

export const cancelAppointment = async ({ clinic, date, ID, birthday }, user) =>
  apiRequest("POST", bookingPath(user, "/cancel"), {
    auth: isFrontDeskUser(user),
    body: { db: currentDb(), clinic, date, ID, birthday },
  });

const emptyClosure = (ID) => ({ ID, data: { hansheng: {}, yoyo: {} } });

// 醫師請假與加開時段；patientTable 用於報表頁切換 Demo/正式
export const fetchClosures = async (patientTable) => {
  const res = await apiRequest("GET", "/public/closures", {
    query: { db: patientTable ? dbForPatientTable(patientTable) : currentDb() },
  });
  return { leave: res.leave, extraOpen: res.extraOpen };
};

// 只有 admin 能改。kind: "leave" | "extraOpen"；action: "add" | "remove"
export const updateClosure = async ({ kind, clinic, ymd, hour, action, type }) => {
  const res = await apiRequest("POST", "/staff/closures", {
    auth: true,
    body: { db: currentDb(), kind, clinic, ymd, hour, action, type },
  });
  return res.doc;
};

// 預約頁的注意事項；沒存過時回傳 null（畫面用 notice.js 的預設內容）
export const fetchNotice = async (patientTable) => {
  const res = await apiRequest("GET", "/public/notice", {
    query: { db: patientTable ? dbForPatientTable(patientTable) : currentDb() },
  });
  return res.notice;
};

// 只有 admin 能改。回傳更新後的全部診所內容
export const updateNotice = async ({ clinic, title, items }, patientTable) => {
  const res = await apiRequest("PUT", "/staff/notice", {
    auth: true,
    body: {
      db: patientTable ? dbForPatientTable(patientTable) : currentDb(),
      clinic,
      title,
      items,
    },
  });
  return res.notice;
};

// 員工讀病歷：admin 拿到完整資料，診所櫃台只拿到看診紀錄。找不到回傳 null
export const fetchPatient = async (ID) => {
  const res = await apiRequest("POST", "/staff/patients/get", {
    auth: true,
    body: { db: currentDb(), ID },
  });
  return res.patient;
};

// 管理頁一天的病人一次查完：回傳 { ID(大寫): patient | null }，每筆內容與 fetchPatient 相同。
// 後端一次最多 100 個 ID，超過就分批；失敗時丟出 ApiError，由呼叫端決定是否退回逐筆查詢。
export const PATIENT_BATCH_LIMIT = 100;
export const fetchPatients = async (IDs) => {
  const unique = [...new Set(IDs)];
  const patients = {};
  for (let i = 0; i < unique.length; i += PATIENT_BATCH_LIMIT) {
    const res = await apiRequest("POST", "/staff/patients/batch", {
      auth: true,
      body: { db: currentDb(), IDs: unique.slice(i, i + PATIENT_BATCH_LIMIT) },
    });
    Object.assign(patients, res.patients || {});
  }
  return patients;
};

export const savePatient = async (patient) => {
  try {
    const res = await apiRequest("PUT", "/staff/patients", {
      auth: true,
      body: { db: currentDb(), patient },
    });
    // 回傳後端存好的病歷（含伺服器蓋的 lastModifyDate / lastModifyDateUser），沒有就回 true
    return res?.patient || true;
  } catch (err) {
    console.error("[savePatient] failed:", err.code || err.message);
    return false;
  }
};

const dataToSort = (inputData) => {
  const outputData = {};
  inputData.forEach((item) => {
    const [dateSlot, timeSlot] = item.date.split("_");
    if (!outputData[dateSlot]) {
      outputData[dateSlot] = {};
    }
    if (!outputData[dateSlot][timeSlot]) {
      outputData[dateSlot][timeSlot] = [];
    }
    const { date: _itemDate, ...rest } = item;
    outputData[dateSlot][timeSlot].push(rest);
  });
  return outputData;
};

// 把後端回傳的預約清單套到排班表上，算出每個時段是否額滿
const buildSchedule = (clinic_name, items, leave, extraOpen) => {
  const currentToday = config.getUTC8Time();
  const todayymd = config.gettodayymd();
  const onDaysData = Object.assign(
    {},
    ondays(currentToday, scheduleWeeks, clinic_name, effectivePastWeeks)
  );
  const baseData = updateOndaysData(dataToSort(items), onDaysData);
  const extraOpenRecord = extraOpen || emptyClosure("extraOpen");
  return {
    originalData_temp: items,
    data_temp: applyExtraOpenForClinic(baseData, extraOpenRecord, clinic_name),
    baseData,
    extraOpenRecord,
    leaveRecord: leave || emptyClosure("leave"),
    todayymd,
  };
};

// error：失敗原因（ApiError），讓呼叫端能顯示對應訊息
const failedSchedule = (error = null) => ({
  originalData_temp: false,
  data_temp: false,
  baseData: false,
  extraOpenRecord: null,
  leaveRecord: null,
  todayymd: config.gettodayymd(),
  error,
});

/**
 * 公開預約頁的時段資料。後端只回傳每筆預約的日期、時段、診別、是否初診，不含個資。
 *
 * @param {string} clinic_name - "hansheng" 或 "yoyo"
 */
export const fetchData = async (clinic_name) => {
  try {
    const res = await apiRequest("GET", "/public/availability", {
      query: { db: currentDb(), clinic: clinic_name },
    });
    return buildSchedule(clinic_name, res.bookings, res.leave, res.extraOpen);
  } catch (err) {
    console.error("[fetchData] failed:", err.code || err.message);
    return failedSchedule();
  }
};

/**
 * 員工管理頁的時段資料（含完整預約資料）。
 *
 * @param {string} clinic_name - "hansheng"、"yoyo" 或 "all"（僅 admin）
 */
export const fetchStaffSchedule = async (clinic_name) => {
  try {
    const res = await apiRequest("GET", "/staff/schedule", {
      auth: true,
      query: { db: currentDb(), clinic: clinic_name },
    });
    return buildSchedule(clinic_name, res.appointments, res.leave, res.extraOpen);
  } catch (err) {
    console.error("[fetchStaffSchedule] failed:", err.code || err.message);
    return failedSchedule(err);
  }
};

export const postAppRecord = async (data) => {
  const url =
    "https://8nkgc9n0a6.execute-api.ap-northeast-1.amazonaws.com/prod/app_record";
  // const data = {
  //   "clinic data": {
  //     test: 123,
  //   },
  // };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      console.error("app_record 回應非 2xx:", response.status);
      return false;
    }
    let resBody = null;
    try {
      resBody = await response.json();
    } catch (_e) {}
    console.log("成功發送資料到 app_record", resBody || "");
    return true;
  } catch (error) {
    console.error("發送資料到 app_record 時發生錯誤:", error);
    return false;
  }
};

export const getReportMonthStartDate = (monthYear) => `${monthYear}-01`;

function filterPatientItemsByMonth(items, monthYear) {
  const monthStart = getReportMonthStartDate(monthYear);
  const [year, month] = monthYear.split("-").map(Number);
  const nextMonth =
    month === 12
      ? `${year + 1}-01`
      : `${year}-${String(month + 1).padStart(2, "0")}`;
  const monthEndExclusive = `${nextMonth}-01`;

  return items
    .map((element) => {
      if (!element.data) {
        return element;
      }
      const filteredData = {};
      let hasOldData = false;
      let firstNewDate = null;

      Object.entries(element.data).forEach(([date, value]) => {
        if (date >= monthStart && date < monthEndExclusive) {
          filteredData[date] = value;
          if (!firstNewDate || date < firstNewDate) {
            firstNewDate = date;
          }
        } else if (date < monthStart) {
          hasOldData = true;
        }
      });

      if (firstNewDate) {
        filteredData[firstNewDate] = {
          ...filteredData[firstNewDate],
          first: !hasOldData,
          notFirst: hasOldData,
        };
      }
      return { ...element, data: filteredData };
    })
    .filter((element) => element.data && Object.keys(element.data).length > 0);
}

function appointmentsToPatientItems(appointments) {
  const byId = {};
  (appointments || []).forEach((appointment) => {
    const id = appointment?.ID;
    const dateSlot = String(appointment?.date || "").split("_")[0];
    if (!id || !dateSlot || id === "leave" || id === "extraOpen") {
      return;
    }
    if (!byId[id]) {
      byId[id] = {
        ID: id,
        name: appointment.name || "",
        birthday: appointment.birthday,
        clinic: appointment.clinic,
        first: appointment.first,
        referral: appointment.referral,
        data: {},
      };
    }
    if (!byId[id].data[dateSlot]) {
      byId[id].data[dateSlot] = {
        first: !!appointment.first,
        arrived: appointment.arrived === true,
        doctor: appointment.doctor,
        hour: appointment.hour,
        time: appointment.time,
      };
    }
  });
  return Object.values(byId);
}

function mergeAppointmentsIntoReportPatients(patients, appointments) {
  const byId = {};
  (patients || []).forEach((person) => {
    if (!person?.ID) {
      return;
    }
    byId[person.ID] = {
      ...person,
      data: { ...(person.data || {}) },
    };
  });
  appointmentsToPatientItems(appointments).forEach((person) => {
    if (!byId[person.ID]) {
      byId[person.ID] = person;
      return;
    }
    Object.entries(person.data || {}).forEach(([date, visit]) => {
      if (!byId[person.ID].data[date]) {
        byId[person.ID].data[date] = visit;
      }
    });
  });
  return Object.values(byId);
}

export const fetchReportData = async (
  patientTableName,
  clinic,
  monthYear,
  appointmentTableName
) => {
  const db = dbForPatientTable(patientTableName);

  let patients = [];
  try {
    const res = await apiRequest("GET", "/staff/report/patients", {
      auth: true,
      query: { db, clinic, since: getReportMonthStartDate(monthYear) },
    });
    patients = filterPatientItemsByMonth(res.patients, monthYear);
  } catch (err) {
    console.error(
      `Unable to retrieve report data for ${clinic}/${monthYear}:`,
      err.code || err.message
    );
  }

  let appointments = [];
  if (appointmentTableName) {
    try {
      const res = await apiRequest("GET", "/staff/report/appointments", {
        auth: true,
        query: { db, month: monthYear },
      });
      appointments = res.appointments;
    } catch (err) {
      console.error(
        `Unable to retrieve appointments for ${monthYear}:`,
        err.code || err.message
      );
    }
  }

  return mergeAppointmentsIntoReportPatients(patients, appointments);
};
